import { getImgeUrl } from 'src/environments/environment';
import { CommonModule, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AdminService } from 'src/app/admin/admin.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginationComponent } from 'src/app/admin/pagination/pagination.component';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';

@Component({
  selector: 'app-book-list',
  standalone: true,
  imports: [NgFor, RouterModule, ReactiveFormsModule, PaginationComponent, CommonModule],
  templateUrl: './book-list.component.html',
  styleUrl: './book-list.component.scss'
})
export class BookListComponent {

  books
  filter_form: FormGroup
  language = 1
  languages:any
  page = 1
  number_of_page = 1
  paginatedData: any[];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number;
  totalPages
  book_categories: any
  imageUrl = getImgeUrl()
  filter:any = {
    "title": "", 
    "authors": "",
    "book_category":0,
    "page": 1, 
    "lang": this.language
  }
  isToggled = false;

  type
  constructor(
    private adminService: AdminService,
    private formBuilder: FormBuilder,
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute
  ) {
    this.itemsPerPage = this.adminService.ITEM_PERPAGE
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });


  }

	

  toggleTheme() {
      this.themeService.toggleTheme();
  }


  ngOnInit(): void {

    this.createFilterForm()
    this.getLanguage()
    this.activeRouter.paramMap.subscribe(params => {
      this.type = params.get('category');
      this.getBookCategory()
    });

    // this.getArticleType()
  }

  getData() {
    if (this.type) {
      this.book_categories.forEach(tp => {
        if (tp.category_name.toLowerCase() == this.type.toLowerCase()) {
          this.filter_form.get("book_category").setValue(tp.id)
          console.info("here commed")
        }
      });
      this.applyFilter()

    } else {
      this.getBooks()
    }
  }
  getLanguage() {
    this.languages = this.adminService.getWebsiteLanguages()
  }

  getBookCategory() {
    this.adminService.getBookCategory().subscribe({
      next: (res) => {
        this.book_categories = res
        this.getData()
      }
    })
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.filter["page"] = page
    this.getBooks();
  }


  createFilterForm() {
    this.filter_form = this.formBuilder.group({
      title: ["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      authors: ["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      book_category:["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      content_language: ['', Validators.pattern(/^[a-zA-Z0-9]*$/)],
    })
  }

  applyFilter() {
    if(this.filter_form.invalid) return 
    let lang = this.filter_form.get("content_language").value
    if (lang) {
      this.language = lang
    }
    const data = this.filter_form.value

    this.filter = {
      "title": data.title?data.title:"", 
      "authors": data.authors? data.authors:"",
      "book_category": data.book_category? data.book_category:0,
      "page": 1, 
      "lang": this.language
    }

    

    this.getBooks()

    

  }

  resetFilter() {
    this.filter_form.reset()
    this.filter.title = ""
    this.filter.lang = 1
    this.filter.authors = ""
    this.filter.book_category = 0
    this.getBooks()
  }
  getBooks() {
    this.adminService.getRecordList(this.adminService.BOOK_URL, this.filter).subscribe({
      next: (res) => {
        this.books = res["data"]
        this.totalItems = res["total_records"]
        console.log("page", this.number_of_page)

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }
}
